import { env } from "./runtimeEnv";

/**
 * The product brand this deployment runs as, from `REACT_APP_BRAND`.
 *
 * Both brands ship in every image; the container's environment picks one.
 * `applyBrand` stamps it on `<html data-brand>`, so a brand palette is a
 * `:root[data-brand="…"]` block in `styles/_tokens.scss`, not a rebuild.
 */
export type BrandId = "elmscare" | "aiutante";

export interface Brand {
    id: BrandId;
    /** Product name in the sidebar and on the boot screen. */
    name: string;
    /** Browser tab title. */
    title: string;
}

const BRANDS: Record<BrandId, Brand> = {
    elmscare: { id: "elmscare", name: "ElmsCare", title: "ElmsCare Organisation Admin" },
    aiutante: { id: "aiutante", name: "Aiutante", title: "Aiutante Organisation Admin" },
};

export const DEFAULT_BRAND: BrandId = "elmscare";

export function resolveBrand(raw: string | undefined): Brand {
    const id = raw?.trim().toLowerCase();
    return id != null && id in BRANDS ? BRANDS[id as BrandId] : BRANDS[DEFAULT_BRAND];
}

export const brand: Brand = resolveBrand(env("REACT_APP_BRAND"));

export function applyBrand(target: Brand = brand): void {
    document.documentElement.dataset.brand = target.id;
    document.title = target.title;
}
